(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  // En-tête : ombre quand on défile
  const header = $('.e-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-stuck', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Apparition au défilement
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.e-rv').forEach((el) => io.observe(el));
  } else {
    $$('.e-rv').forEach((el) => el.classList.add('in'));
  }

  // Galerie produit : l'image ne change qu'une fois la suivante chargée (ni blanc, ni saut)
  const main = $('#e-main-img');
  const thumbs = $$('.e-thumbs button');
  const idle = window.requestIdleCallback || ((f) => setTimeout(f, 1200));
  const cache = new Map();
  const preload = (url) => {
    if (!url) return Promise.resolve();
    if (!cache.has(url)) {
      cache.set(url, new Promise((done) => {
        const im = new Image();
        im.onload = im.onerror = () => done(url);
        im.src = url;
        if (im.decode) im.decode().then(() => done(url)).catch(() => {});
      }));
    }
    return cache.get(url);
  };
  if (main && thumbs.length > 1) {
    let cur = Math.max(0, thumbs.findIndex((b) => b.classList.contains('on')));
    let token = 0;
    const show = (n) => {
      const i = (n + thumbs.length) % thumbs.length;
      if (i === cur) return;
      cur = i;
      const my = ++token;
      const url = thumbs[i].dataset.src;
      thumbs.forEach((x, k) => x.classList.toggle('on', k === i));
      preload(url).then(() => {
        if (my !== token) return; // un clic plus récent a pris la main
        main.style.opacity = 0;
        setTimeout(() => {
          if (my !== token) return;
          main.removeAttribute('srcset');
          main.src = url;
          requestAnimationFrame(() => { main.style.opacity = 1; });
        }, 130);
      });
    };
    thumbs.forEach((bt, i) => {
      bt.addEventListener('click', () => show(i));
      bt.addEventListener('pointerenter', () => preload(bt.dataset.src), { once: true });
    });
    idle(() => thumbs.forEach((bt) => preload(bt.dataset.src)));
    // Grande image : un clic passe à la suivante, un glissement du doigt va à la suivante ou à la précédente
    const frame = main.closest('.e-gallery__main');
    if (frame) {
      frame.classList.add('is-swipe');
      let x0 = null, swiped = false;
      frame.addEventListener('pointerdown', (e) => { x0 = e.clientX; swiped = false; });
      frame.addEventListener('pointerup', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0; x0 = null;
        if (Math.abs(dx) > 36) { swiped = true; show(cur + (dx < 0 ? 1 : -1)); }
      });
      frame.addEventListener('pointercancel', () => { x0 = null; });
      frame.addEventListener('click', () => { if (!swiped) show(cur + 1); swiped = false; });
    }
  }

  // Livre à feuilleter (StPageFlip chargé seulement quand la section approche)
  $$('[data-book]').forEach((book) => {
    const stage = $('.e-book__stage', book);
    const flipEl = $('.e-book__flip', book);
    const pages = $$('.e-book__page', book);
    const prev = $('[data-book-prev]', book), next = $('[data-book-next]', book);
    const cap = $('[data-book-cap]', book), txt = $('[data-book-txt]', book), num = $('[data-book-n]', book);
    const total = pages.length;
    let pf = null, loading = false, pending = null;
    const warm = (i) => { for (let k = i - 2; k <= i + 4; k++) { const im = pages[k] && $('img', pages[k]); if (im && im.loading === 'lazy') im.loading = 'eager'; } };
    const update = (i) => {
      const p = pages[i]; if (!p) return;
      const land = pf && pf.getOrientation && pf.getOrientation() === 'landscape';
      const pair = land && i > 0 && i + 1 < total;
      cap.textContent = pair ? p.dataset.cap + ' · ' + pages[i + 1].dataset.cap : p.dataset.cap;
      txt.textContent = pair ? pages[i + 1].dataset.txt : p.dataset.txt;
      num.textContent = (pair ? (i + 1) + '-' + (i + 2) : (i + 1)) + ' / ' + total;
      prev.disabled = i <= 0;
      next.disabled = land ? i >= total - (i % 2 ? 2 : 1) : i >= total - 1;
      warm(i);
    };
    const go = (i) => { if (pf) pf.flip(i); else pending = i; };
    const init = () => {
      if (pf || !window.St || !window.St.PageFlip) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      pf = new window.St.PageFlip(flipEl, {
        width: 450, height: 638, size: 'stretch', minWidth: 260, maxWidth: 480, minHeight: 360, maxHeight: 900,
        showCover: true, usePortrait: true, autoSize: true, mobileScrollSupport: true,
        maxShadowOpacity: 0.35, flippingTime: reduce ? 1 : 750, showPageCorners: true, swipeDistance: 24
      });
      pf.loadFromHTML(pages);
      book.classList.add('is-ready');
      pf.on('flip', (e) => update(e.data));
      pf.on('changeOrientation', () => update(pf.getCurrentPageIndex()));
      update(0);
      idle(() => pages.forEach((pg) => { const im = $('img', pg); if (im) im.loading = 'eager'; }));
      if (pending !== null) { const n = pending; pending = null; pf.turnToPage(n); update(pf.getCurrentPageIndex()); }
    };
    const load = () => {
      if (loading) return; loading = true;
      warm(0);
      if (window.St && window.St.PageFlip) { init(); return; }
      const sc = document.createElement('script');
      sc.src = book.dataset.lib; sc.defer = true; sc.crossOrigin = 'anonymous';
      if (book.dataset.sri) sc.integrity = book.dataset.sri;
      sc.onload = init;
      sc.onerror = () => book.classList.add('is-fallback');
      document.head.appendChild(sc);
    };
    prev.addEventListener('click', () => { load(); if (pf) pf.flipPrev(); });
    next.addEventListener('click', () => { load(); if (pf) pf.flipNext(); else pending = 1; });
    stage.addEventListener('keydown', (ev) => {
      if (ev.key === 'ArrowRight') { ev.preventDefault(); if (pf) pf.flipNext(); }
      if (ev.key === 'ArrowLeft') { ev.preventDefault(); if (pf) pf.flipPrev(); }
    });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((en) => { if (en.some((e) => e.isIntersecting)) { io.disconnect(); load(); } }, { rootMargin: '500px 0px' });
      io.observe(book);
    } else { load(); }
    $$('[data-flip-go]').forEach((a) => a.addEventListener('click', () => { load(); go(Number(a.dataset.flipGo) - 1); }));
  });

  // Formulaires d'inscription : n'afficher le succès que sur le formulaire envoyé
  if (/[?&]customer_posted=true/.test(location.search) && location.hash) {
    $$('form').forEach((f) => {
      const ok = $('[data-posted]', f), alt = $('[data-posted-alt]', f);
      if (ok && alt && '#' + f.id !== location.hash) { ok.remove(); alt.hidden = false; }
    });
  }
  // Extrait offert : bouton de téléchargement seulement si le fichier existe
  $$('[data-lead-dl]').forEach((a) => {
    const mail = a.parentElement.querySelector('[data-lead-mail]');
    fetch(a.href, { method: 'HEAD' }).then((r) => {
      const ok = r.ok;
      a.hidden = !ok; if (mail) mail.hidden = ok;
    }).catch(() => { a.hidden = true; if (mail) mail.hidden = false; });
  });

  // Consentement contenu numérique : obligatoire avant paiement
  $$('form.e-buy').forEach((form) => {
    const box = $('.e-consent', form);
    const cb = box && $('input', box);
    const dyn = $('.e-dyn', form);
    if (!cb) return;
    const sync = () => { if (dyn) dyn.classList.toggle('is-locked', !cb.checked); if (cb.checked) box.classList.remove('is-err'); };
    sync();
    cb.addEventListener('change', sync);
    form.addEventListener('submit', (ev) => {
      if (!cb.checked) {
        ev.preventDefault();
        box.classList.remove('is-err'); void box.offsetWidth; box.classList.add('is-err');
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
    if (dyn) dyn.addEventListener('click', (ev) => {
      if (!cb.checked) { ev.preventDefault(); ev.stopPropagation(); box.classList.add('is-err'); }
    }, true);
  });

  // Barre d'achat collante
  const sticky = $('#e-sticky');
  const anchor = $('[data-sticky-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    // Mobile : la barre reste visible tant que la zone d'achat n'est pas à l'écran (avant comme après)
    const mq = window.matchMedia('(max-width: 989px)');
    const sync = () => {
      const r = anchor.getBoundingClientRect();
      const inView = r.bottom > 0 && r.top < window.innerHeight;
      sticky.classList.toggle('on', !inView && (mq.matches ? window.scrollY > 240 : r.top < 0));
    };
    sync();
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
  } else if (sticky) {
    window.addEventListener('scroll', () => sticky.classList.toggle('on', window.scrollY > 700), { passive: true });
  }

  // FAQ : une seule question ouverte à la fois
  $$('[data-accordion]').forEach((group) => {
    $$('details', group).forEach((d) => d.addEventListener('toggle', () => {
      if (d.open) $$('details', group).forEach((o) => { if (o !== d) o.open = false; });
    }));
  });

  // Menu mobile : fermer au clic sur un lien
  $$('.e-drawer a').forEach((a) => a.addEventListener('click', () => { const d = a.closest('details'); if (d) d.open = false; }));
  // Upsell : ajoute les deux livres puis va au paiement
  $$('form.e-buy').forEach((form) => {
    const up = $('.e-upsell[data-upsell]', form);
    const cb = up && $('.e-upsell__cb', up);
    if (!cb) return;
    cb.addEventListener('change', () => up.classList.toggle('on', cb.checked));
    form.addEventListener('submit', async (ev) => {
      if (!cb.checked) return;
      ev.preventDefault();
      const btn = $('button[type=submit]', form);
      if (btn) btn.disabled = true;
      const fd = new FormData(form);
      const props = {};
      for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m) props[m[1]] = v; }
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [
            { id: Number(fd.get('id')), quantity: 1, properties: props },
            { id: Number(up.dataset.upsell), quantity: 1 }
          ] })
        });
        if (!r.ok) throw new Error('cart');
        window.location.href = '/checkout';
      } catch (e) {
        if (btn) btn.disabled = false;
        HTMLFormElement.prototype.submit.call(form);
      }
    });
  });
  // Extraits du livre : défilement
  $$('[data-quotes]').forEach((box) => {
    const qs = $$('blockquote', box), dots = $('.e-quote__dots', box);
    if (qs.length < 2) return;
    let i = 0;
    dots.innerHTML = qs.map(() => '<i></i>').join('');
    const show = (n) => { i = (n + qs.length) % qs.length; qs.forEach((q, k) => q.classList.toggle('on', k === i)); $$('i', dots).forEach((d, k) => d.classList.toggle('on', k === i)); };
    show(0);
    $$('[data-q]', box).forEach((b) => b.addEventListener('click', () => { show(i + Number(b.dataset.q)); clearInterval(t); }));
    const t = setInterval(() => show(i + 1), 5500);
  });
})();
// Stories : cercles façon Instagram, vidéo ou image
(() => {
  const row = document.querySelector('[data-stories]');
  const sv = document.querySelector('[data-sv]');
  if (!row || !sv) return;
  const items = [...row.querySelectorAll('[data-story]')];
  const media = sv.querySelector('[data-sv-media]');
  const bars = sv.querySelector('[data-sv-bars]');
  const label = sv.querySelector('[data-sv-label]');
  const muteBtn = sv.querySelector('[data-sv-mute]');
  let i = 0, timer = null, raf = null, last = null;
  const seenKey = 'ebh-stories-seen:' + location.pathname;
  let seen = [];
  try { seen = JSON.parse(localStorage.getItem(seenKey) || '[]'); } catch (e) {}
  const mark = (k) => { items[k].classList.add('is-seen'); const id = items[k].dataset.label; if (!seen.includes(id)) seen.push(id); try { localStorage.setItem(seenKey, JSON.stringify(seen)); } catch (e) {} };
  items.forEach((b) => { if (seen.includes(b.dataset.label)) b.classList.add('is-seen'); });
  const ready = new Map();
  const preloadStory = (url) => {
    if (!url) return Promise.resolve();
    if (!ready.has(url)) ready.set(url, new Promise((done) => { const im = new Image(); im.onload = im.onerror = () => done(); im.src = url; }));
    return ready.get(url);
  };
  (window.requestIdleCallback || ((f) => setTimeout(f, 1500)))(() => items.forEach((b) => { if (!b.dataset.src) preloadStory(b.dataset.img); }));
  bars.innerHTML = items.map(() => '<i><b></b></i>').join('');
  const fills = [...bars.querySelectorAll('b')];
  const stop = () => { clearTimeout(timer); cancelAnimationFrame(raf); const v = media.querySelector('video'); if (v) v.pause(); };
  const show = (k) => {
    stop();
    if (k < 0) k = 0;
    if (k >= items.length) return close();
    i = k; mark(k);
    fills.forEach((f, n) => { f.style.width = n < k ? '100%' : '0'; });
    const it = items[k];
    label.textContent = it.dataset.label || '';
    media.innerHTML = '';
    if (it.dataset.src) {
      const v = document.createElement('video');
      v.src = it.dataset.src; v.poster = it.dataset.img || ''; v.playsInline = true; v.autoplay = true; v.muted = false; v.preload = 'auto';
      media.appendChild(v);
      muteBtn.hidden = false;
      v.play().catch(() => { v.muted = true; v.play().catch(() => {}); });
      const tick = () => { if (v.duration) fills[k].style.width = (v.currentTime / v.duration * 100) + '%'; raf = requestAnimationFrame(tick); };
      tick();
      v.addEventListener('ended', () => show(i + 1));
    } else {
      muteBtn.hidden = true;
      const im = document.createElement('img');
      im.src = it.dataset.img; im.alt = it.dataset.label || ''; im.className = 'is-page';
      media.appendChild(im);
      const D = 5000;
      // le décompte ne démarre qu'une fois l'image affichée
      preloadStory(it.dataset.img).then(() => {
        if (i !== k || sv.hidden) return;
        const t0 = performance.now();
        const tick = (t) => { fills[k].style.width = Math.min(100, (t - t0) / D * 100) + '%'; raf = requestAnimationFrame(tick); };
        raf = requestAnimationFrame(tick);
        timer = setTimeout(() => show(i + 1), D);
      });
      if (items[k + 1] && !items[k + 1].dataset.src) preloadStory(items[k + 1].dataset.img);
    }
  };
  const open = (k) => { last = document.activeElement; sv.hidden = false; document.documentElement.style.overflow = 'hidden'; show(k); sv.querySelector('[data-sv-close]').focus(); };
  const close = () => { stop(); media.innerHTML = ''; sv.hidden = true; document.documentElement.style.overflow = ''; if (last) last.focus(); };
  items.forEach((b, k) => b.addEventListener('click', () => open(k)));
  sv.querySelector('[data-sv-close]').addEventListener('click', close);
  sv.querySelector('[data-sv-next]').addEventListener('click', () => show(i + 1));
  sv.querySelector('[data-sv-prev]').addEventListener('click', () => show(i - 1));
  sv.querySelector('[data-sv-cta]').addEventListener('click', close);
  muteBtn.addEventListener('click', () => { const v = media.querySelector('video'); if (v) v.muted = !v.muted; });
  sv.addEventListener('click', (e) => { if (e.target === sv) close(); });
  document.addEventListener('keydown', (e) => {
    if (sv.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowRight') show(i + 1);
    if (e.key === 'ArrowLeft') show(i - 1);
  });
})();
